module.exports = window["wp"]["shortcode"];